export default {
  created() {
    const routeMeta = this.$route.meta;
    if (routeMeta && routeMeta.bodyClass) {
      const bodyElement = document.body;
      bodyElement.className = '';
      bodyElement.classList.add(routeMeta.bodyClass);
    }
  },
};